import { editor } from '@/instance';
import { useEditorModel } from '@/store/models/editor-model';
import { usePluginModel } from '@/store/models/plugin-model';

export const useMattingPluginHelper = () => {
    const setIsMatting = usePluginModel((state) => state.setIsMatting);
    const setIsShowPanel = useEditorModel((state) => state.setIsShowPanel);
    const setIsShowCollapse = useEditorModel((state) => state.setIsShowCollapse);
    const clearProcessingMattingImgInfo = usePluginModel((state) => state.clearProcessingMattingImgInfo);
    const setIsMattingMainLayer = usePluginModel((state) => state.setIsMattingMainLayer);
    const setIsDisable = useEditorModel((state) => state.setIsDisable);

    // 打开
    const show = (isMainLayer?: boolean) => {
        setIsMatting(true);
        setIsMattingMainLayer(!!isMainLayer);
        setIsDisable(true);
        setIsShowPanel(false);
        setIsShowCollapse(false);
        editor.disableOperate();
    };

    // 关闭
    const close = () => {
        setIsDisable(false);
        setIsShowPanel(true);
        setIsShowCollapse(true);
        editor.enableOperate();
        clearProcessingMattingImgInfo();
        setIsMattingMainLayer(false);
        setIsMatting(false);
    };

    return {
        show,
        close,
    };
};
